/** Мінімальна довжина пароля нового облікового запису (прототип v4: «Щонайменше 8 символів»). */
const MIN_PASSWORD = 8;

/**
 * Перевірка форми реєстрації в порядку прототипу v4 (submitAuth): ім'я, формат e-mail (^\S+@\S+\.\S+$), пароль ≥ 8 символів; код помилки
 * або null. Зайнятість адреси перевіряє сервер (email_taken). Чиста функція.
 */
export function registrationError(name: string, email: string, password: string): string | null {
  if (!name.trim()) return 'name_required';
  if (!/^\S+@\S+\.\S+$/.test(email.trim().toLowerCase())) return 'email_invalid';
  if (password.length < MIN_PASSWORD) return 'password_short';
  return null;
}
